import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-black text-gray-200 pt-14 pb-6 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4">
        {/* Top area */}
        <div className="grid gap-10 lg:grid-cols-4 md:grid-cols-3">
          {/* Brand / story */}
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              {/* Logo block */}
              <div className="flex items-center h-10">
                <img
                  className="h-10 w-auto object-contain"
                  src="/images/logo.png"
                  alt="Russh Berry"
                />
              </div>
              <div className="flex items-center h-10">
                <h3
                  className="text-lg m-0"
                  style={{
                    fontFamily: "'TAN PEARL', serif",
                    lineHeight: "1",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  Russh Berry
                </h3>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
              Curated couture, premium streetwear and timeless essentials,
              crafted for those who treat every day like a runway.
            </p>
          </div>

          {/* Shop links */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.25em] uppercase text-gray-400 mb-4">
              Shop
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  New Arrivals
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/collections/women"
                  className="hover:text-white transition-colors"
                >
                  Women
                </Link>
              </li> */}
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Men
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Accessories
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Archive / Sale
                </Link>
              </li>
            </ul>
          </div>

          {/* Help / brand */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.25em] uppercase text-gray-400 mb-4">
              Help & Brand
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/contact"
                  className="hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/shipping-policies"
                  className="hover:text-white transition-colors"
                >
                  Shipping & Returns
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/"
                  className="hover:text-white transition-colors"
                >
                  Store Locator
                </Link>
              </li> */}
              <li>
                <Link
                  to="/about"
                  className="hover:text-white transition-colors"
                >
                  About Russh Berry
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="hover:text-white transition-colors"
                >
                  Privacy & Policies
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact form / newsletter / Payment */}
          <div className="flex flex-col gap-6">
            <div>
              <h4 className="text-xs font-semibold tracking-[0.25em] uppercase text-gray-400 mb-3">
                Stay In The Circle
              </h4>
              <p className="text-xs text-gray-400 mb-3">
                Be the first to know about limited drops, private sales and
                studio stories.
              </p>

              {/* Newsletter + contact mini form */}
              <form
                className="space-y-3"
                onSubmit={(e) => {
                  e.preventDefault();
                  // handle submit here
                }}
              >
                <div>
                  <input
                    type="email"
                    required
                    placeholder="Email address"
                    className="w-full bg-white/5 border border-white/15 text-xs rounded-none px-3 py-2 outline-none focus:border-white focus:ring-1 focus:ring-white placeholder:text-gray-500"
                  />
                </div>
                <div>
                  <textarea
                    rows="2"
                    placeholder="Message (optional)"
                    className="w-full bg-white/5 border border-white/15 text-xs rounded-none px-3 py-2 outline-none focus:border-white focus:ring-1 focus:ring-white placeholder:text-gray-500 resize-none"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-white text-black text-xs tracking-[0.2em] font-semibold py-2 uppercase hover:bg-neutral-200 transition-colors"
                >
                  Join & Contact
                </button>
              </form>
            </div>

            {/* Secure Payment Icons */}
            {/* <div>
              <h4 className="text-[10px] font-semibold tracking-[0.2em] uppercase text-gray-500 mb-3">
                100% Secure Payment
              </h4>
              <div className="flex items-center gap-4 transition-all duration-300">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/8/89/Razorpay_logo.svg"
                  alt="Razorpay"
                  className="h-8 w-auto bg-white px-2 py-1 rounded"
                />
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg"
                  alt="Visa"
                  className="h-8 w-auto bg-white px-2 py-1 rounded"
                />
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg"
                  alt="Mastercard"
                  className="h-8 w-auto bg-white px-2 py-1 rounded"
                />
              </div>
            </div> */}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 mt-10 pt-5 flex flex-col gap-3">
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] text-gray-500">
            {/* Left side */}
            <p className="uppercase tracking-[0.25em] text-center md:text-left">
              © {new Date().getFullYear()} Russh Berry. All Rights Reserved.
            </p>
            <div className="center">
              <span className="text-[10px] text-center tracking-[0.2em] uppercase">
                Made with <span className="text-red-500">♥</span> by{" "}
                <a
                  href="https://webzark.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="underline-offset-4 hover:underline hover:text-gray-300"
                >
                  Webzark Technologies
                </a>
              </span>
            </div>
            {/* Right side */}
            <div className="flex flex-wrap items-center justify-center md:justify-end gap-3">
              <a
                href="#"
                target="_blank"
                rel="noreferrer"
                className="hover:text-white transition-colors"
              >
                Instagram
              </a>

              <span className="hidden md:inline-block h-[1px] w-5 bg-white/20" />
              <Link to="/" className="hover:text-white transition-colors">
                Terms
              </Link>
              <span className="hidden md:inline-block h-[1px] w-5 bg-white/20" />
              <Link to="/" className="hover:text-white transition-colors ml-1">
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
